import {Component, Input, OnInit} from '@angular/core';
import * as _ from 'lodash'
import { isNullOrUndefined } from 'util';
import { MasterSummaryPDModel } from '../../../../models/survey/survey.model';
import { ROSE_CHART_COLORS } from '../../../helpers/chart-helper';
import { CommunicationService } from '../../../services/communication.service';

@Component({
  selector: 'app-stacked-bar-chart',
  templateUrl: './stacked-bar-chart.component.html',
  styleUrls: ['./stacked-bar-chart.component.less']
})
export class StackedBarChartComponent implements OnInit {

  @Input() dataSource: MasterSummaryPDModel;
  @Input("chartJ") chartJ: number;
  @Input() isSelectedAllResponses: boolean;

  isLoading = false;
  chartOption: any;
  oldDataSource: string;

  initOpts = {
    renderer: 'svg',
    width: 700,
    height: 0
  };

  constructor(private communicationService: CommunicationService) {
  }

  ngOnInit() {
    this.communicationService.scrollDataChanged.subscribe(() => {
        if (this.oldDataSource !== JSON.stringify(this.dataSource)) {
            this.oldDataSource = JSON.stringify(this.dataSource);
            this.initChart();
        }
    })
    this.initChart();
  }

  private initChart() {
    this.isLoading = true;
    let chartHeight = 0;
    const barHeight = 40;

    let categories = [];
    let averageValues = [];
    let dataSeries = [];
    let listAnswers = [];

    if (this.isSelectedAllResponses) {
      const question = this.dataSource.listQuestionModel[this.chartJ];
      if (!isNullOrUndefined(question)) {
        categories.push('All responses');
        averageValues.push(this.getAverageValue(question));
        if (question.listAnswerModel) {
          listAnswers.push({
            segment: 'All responses',
            answers: question.listAnswerModel
          });
        }
      }
    }
    if (this.dataSource.listSurveyVersionQuestion && this.dataSource.listSurveyVersionQuestion.length > 0) {
      this.dataSource.listSurveyVersionQuestion.forEach(surveyQuestion => {
        const question = surveyQuestion.listQuestionModel[this.chartJ];
        if (!isNullOrUndefined(question)) {
          categories.push(surveyQuestion.surveyName);
          averageValues.push(this.getAverageValue(question));
          if (question.listAnswerModel) {
            listAnswers.push({
              segment: surveyQuestion.surveyName,
              answers: question.listAnswerModel
            });
          }
        }
      })
    }
    if (this.dataSource.listSurveyCutQuestion && this.dataSource.listSurveyCutQuestion.length > 0) {
      this.dataSource.listSurveyCutQuestion.forEach(surveyQuestion => {
        const question = surveyQuestion.listQuestionModel[this.chartJ];
        if (!isNullOrUndefined(question)) {
          categories.push(surveyQuestion.surveyName);
          averageValues.push(this.getAverageValue(question));
          if (question.listAnswerModel) {
            listAnswers.push({
              segment: surveyQuestion.surveyName,
              answers: question.listAnswerModel
            });
          } else {
            if (listAnswers.length > 0) {
              let item = _.cloneDeep(listAnswers[0]);
              item.segment = surveyQuestion.surveyName;
              item.answers.forEach(a => {
                a.answerPercentage = 0;
              });
              listAnswers.push(item);
            }
          }
        }
      })
    }

    if (listAnswers.length > 1) {
      let answers = _.sortBy(listAnswers[0].answers, [function(o) { return o.answerName; }]);
      answers.forEach(a => {
        let answerPercentages = [];
        listAnswers.forEach(la => {
          const answer = _.find(la.answers, function(o) { return o.answerName === a.answerName; });
          const answerPercentage = answer ? answer.answerPercentage : 0;
          answerPercentages.push({
            name: a.answerName,
            value: answerPercentage,
            label: {
              formatter: function (params) {
                return params.value > 0 ? params.name : '';
              }
            },
          });
        })

        dataSeries.push({
          name: a.answerName,
          type: 'bar',
          stack: 'total',
          showBackground: 'true',
          barGap: 0,
          label: {
            show: true
          },
          emphasis: {
            disabled: true,
            focus: 'series'
          },
          tooltip: {
            trigger: 'item',
            borderColor: '#5E5E5E',
            useHTML: true,
            formatter: function (params) {
              let segment = '';
              if (listAnswers.length > params.dataIndex) {
                segment = listAnswers[params.dataIndex].segment;
              }
              
              if (params.value > 0 ) {
                return "<div style='max-width: 418px; white-space:normal;'>" 
                  + segment 
                  + "<br/>" 
                  + "<span style='height: 10px; width: 10px; background-color: " 
                  + params.color + "; border-radius: 50%;display: inline-block;'></span>" 
                  + "<span style='padding-left: 10px;'>" + params.name + "</span>"
                  + "<span style='padding-left: 20px; font-weight: 700;'>" 
                  + params.value + "%</span></div>";
              }
              return segment;
            }
          },
          data: answerPercentages
        });
      })

      this.isLoading = false;
    }

    chartHeight = categories.length * (barHeight + 10);
    this.initOpts.height = chartHeight + 10;
    this.chartOption = {
      color: ROSE_CHART_COLORS,
      animation: false,
      height: chartHeight,
      grid: {
        containLabel: true,
        top: 10,
        right: 10,
        bottom: 10,
        left: 10,
      },
      tooltip: {
        trigger: 'item',
        borderRadius: 0,
        shadowColor: null,
        borderColor: '#5E5E5E',
        axisPointer: {
          type: 'shadow'
        },
      },
      xAxis: {
        type: 'value',
        axisLabel: {
          show: false
        },
        splitLine: {
          show: false
        },
        max: 100
      },
      yAxis: [{
        type: 'category',
        data: categories,
        position: 'left',
        inverse: true,
        axisLabel: {
          formatter: '{value}',
          width: 150,
          align: 'right',
          overflow: 'truncate',
          ellipsis: '...'
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        }
      },
      {
        type: 'category',
        data: averageValues,
        align: 'right',
        inverse: true,
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          formatter: '{value}',
        }
      }],
      series: dataSeries,
    };
  }

  private getAverageValue(question) {
    if (!isNullOrUndefined(question)) {
      return (question.averageValue && question.averageValue > 0 ) ? question.averageValue.toFixed(1) : 0;
    }
    return 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/chart/stacked-bar-chart/stacked-bar-chart.component.ts